module.exports = __webpack_public_path__ + "static/img/about_card02.629ed77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/about_card02.png
// module id = MB+8
// module chunks = 2